var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92734 3.42845L18.2675 3.42845C18.3678 3.42845 18.4882 3.64055 18.5484 3.71725C18.6286 3.79394 18.6487 3.98447 18.6086 4.08034L16.4027 11.0917C16.2823 11.5507 15.8609 11.8167 15.3606 11.8167L6.71761 11.8167C6.21599 11.8167 5.77582 11.589 5.67549 11.13C5.67549 11.13 3.80821 4.0324 3.46961 2.65314C3.12977 1.27268 2.7849 0.70108 1.37158 0.70108",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92734 3.42845L18.2674 3.42845C18.3678 3.42845 18.4882 3.64055 18.5484 3.71725C18.6286 3.79394 18.6487 3.98447 18.6086 4.08034L16.4027 11.0917C16.2823 11.5507 15.8609 11.8167 15.3606 11.8167L6.71761 11.8167C6.21599 11.8167 5.77582 11.589 5.67549 11.13C5.67549 11.13 3.80821 4.0324 3.46961 2.65314C3.12977 1.27268 2.7849 0.70108 1.37158 0.70108",
    stroke: "white",
    strokeWidth: 0.856102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58582 14.7719C9.58582 15.6157 8.86957 16.2989 7.9865 16.2989C7.10342 16.2989 6.38843 15.6157 6.38843 14.7719C6.38843 13.928 7.10342 13.2436 7.9865 13.2436C8.86957 13.2436 9.58582 13.928 9.58582 14.7719Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.757 14.7719C14.757 15.6157 14.0407 16.2989 13.1576 16.2989C12.2746 16.2989 11.5596 15.6157 11.5596 14.7719C11.5596 13.928 12.2746 13.2436 13.1576 13.2436C14.0407 13.2436 14.757 13.928 14.757 14.7719Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e41d2cdbc755c062b84e5b89f5871c8e.svg";
export { ForwardRef as ReactComponent };